import DateFnsUtils from '@date-io/date-fns';
import { yupResolver } from '@hookform/resolvers';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { Checkbox, TextField } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Autocomplete } from '@material-ui/lab';
import { CommonYupValidation } from 'helpers/Form/YupValidation';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation, useParams } from 'react-router';
import * as yup from 'yup';
import {
  useGetAssignedCompanyQuery,
  useGetCompanyNameQuery,
  useGetFaCategoryDropdownListingQuery,
  useGetCostCentreCodeLazyQuery,
  useGetFaLocationLazyQuery,
} from '@account-root/account-react/src/generated/graphql';

interface FALedgerReportByTransactionDateParamsProps {
  CompanyID: string;
  AssetType: string;
  AssetCardNo: string;
  DocNo: string;
  CostCentreID: string;
  LocationID: string;
  StartDate: Date;
  EndDate: Date;
}

interface CompanyOption {
  Name: string;
  CompanyID: string;
}

export const FALedgerReportByTransactionDateParamsForm = (props: any) => {
  let history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const accountID = user.accountID;
  const { CompanyID }: any = useParams();
  let location = useLocation();
  const editData = location?.state as any;
  const latestCompany = localStorage.getItem('latestCompany');
  const ParamsSchema = yup.object().shape({
    CompanyID: CommonYupValidation.requireField('Company is required'),
    StartDate: yup.string().required('Transaction Start Date is required'),
    EndDate: yup.string().required('Transaction End Date is required'),
  });
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const {
    handleSubmit,
    register,
    errors,
    control,
    getValues,
    watch,
    setValue,
  } = useForm<FALedgerReportByTransactionDateParamsProps>({
    defaultValues: {},
    mode: 'all',
    resolver: yupResolver(ParamsSchema),
  });

  const {
    loading: CompanyLoading,
    error: CompanyError,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    variables: { CompanyID },
    fetchPolicy: 'network-only',
    onCompleted: () => {
      if (latestCompany) {
        loadCostCentre({
          variables: {
            CompanyID: latestCompany,
            orderByAsc: 'Code',
            IsLastNode: true,
          }
        })

        loadFALocation({
          variables: {
            CompanyID: latestCompany
          }
        })
      }
    },
  });

  const {
    loading: CompanyAssignedLoading,
    error: CompanyAssignedError,
    data: { getAssignedCompanyByUser } = { getAssignedCompanyByUser: [] },
  } = useGetAssignedCompanyQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {
      if (latestCompany) {
        loadCostCentre({
          variables: {
            CompanyID: latestCompany,
            orderByAsc: 'Code',
            IsLastNode: true,
          }
        })

        loadFALocation({
          variables: {
            CompanyID: latestCompany
          }
        })
      }
    },
  });

  const {
    loading: FACategoryDropdownListingLoading,
    error: FACategoryDropdownListingError,
    data: { getFACategoryDropdownListing } = { getFACategoryDropdownListing: [] },
  } = useGetFaCategoryDropdownListingQuery({
    fetchPolicy: 'network-only',
  });

  const [
    loadCostCentre,
    {
      loading: CostCentreLoading,
      data: { getCostCentre } = {
        getCostCentre: []
      },
    },
  ] = useGetCostCentreCodeLazyQuery({
    fetchPolicy: 'network-only',
  })

  const [
    loadFALocation,
    {
      loading: FALocationLoading,
      data: { getFALocation } = {
        getFALocation: [],
      },
    },
  ] = useGetFaLocationLazyQuery({
    fetchPolicy: 'network-only',
  });

  const [selectedFACategory, setSelectedFACategory] = useState(new Set())

  const handleCheckboxFACategoryChange = (event: any) => {
    let faCategory = selectedFACategory
    event?.target?.checked ? faCategory.add(event?.target?.value) : faCategory.delete(event?.target?.value)
    setSelectedFACategory(new Set(faCategory))
  }

  const [selectedDepartment, setSelectedDepartment] = useState(new Set())

  const handleCheckboxDepartmentChange = (event: any) => {
    let department = selectedDepartment
    event?.target?.checked ? department.add(event?.target?.value) : department.delete(event?.target?.value)
    setSelectedDepartment(new Set(department))
  }

  const [selectedLocation, setSelectedLocation] = useState(new Set())

  const handleCheckboxLocationChange = (event: any) => {
    let location = selectedLocation
    event?.target?.checked ? location.add(event?.target?.value) : location.delete(event?.target?.value)
    setSelectedLocation(new Set(location))
  }

  const onSubmit = data => {
    history.push({
      pathname: `/digital-reports/fixed-assets/fa-ledger-report-by-transaction-date/generated`,
      state: {
        CompanyID: data?.CompanyID,
        AssetType: selectedFACategory ? Array.from(selectedFACategory) : undefined,
        AssetCardNo: data?.AssetCardNo,
        DocNo: data?.DocNo,
        CostCentreID: selectedDepartment ? Array.from(selectedDepartment) : undefined,
        LocationID: selectedLocation ? Array.from(selectedLocation) : undefined,
        StartDate: data?.StartDate ? new Date(data.StartDate) : null,
        EndDate: data?.EndDate ? new Date(data?.EndDate) : null,
      },
    });
  };

  return (
    <>
      {CompanyLoading && <Loading />}
      {CompanyAssignedLoading && <Loading />}
      {FACategoryDropdownListingLoading && <Loading />}
      {CostCentreLoading && <Loading />}
      {FALocationLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => history.push(`/digital-reports/fixed-assets`)}
        smTitle={'Fixed Assets'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'FA Ledger Report By Transaction Date', current: true },
        ]}
        rightRouteSegments={[{ name: 'Parameters', current: true }]}
      />

      <ContentWrapper float>
        <CardContents>
          {!CompanyAssignedLoading && !CompanyLoading && (
            <Controller
              render={({ value, onChange }) => {
                const options: CompanyOption[] =
                  !!user?.superUser === false
                    ? getAssignedCompanyByUser
                    : getCompany;
                const defVal = getCompany?.filter(
                  x => x?.CompanyID === latestCompany,
                )[0];

                return (
                  <Autocomplete
                    options={options || []}
                    getOptionLabel={(option: CompanyOption) => option.Name}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('CompanyID', newValue?.CompanyID);

                      loadCostCentre({
                        variables: {
                          CompanyID: newValue?.CompanyID,
                          orderByAsc: 'Code',
                          IsLastNode: true,
                        }
                      })

                      loadFALocation({
                        variables: {
                          CompanyID: newValue?.CompanyID
                        }
                      })
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.Name}</span>;
                    }}
                    defaultValue={defVal}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.CompanyID?.message}
                            error={errors?.CompanyID ? true : false}
                            label="Company"
                            style={{ width: '100%' }}
                            margin="normal"
                            required
                            defaultValue={defVal}
                          />
                        </div>
                      );
                    }}
                  />
                );
              }}
              label="Company"
              name="CompanyID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.CompanyID?.message}
              error={errors?.CompanyID ? true : false}
              required
              defaultValue={latestCompany}
            />
          )}

          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={getFACategoryDropdownListing || []}
                  getOptionLabel={option => option?.name}
                  fullWidth
                  onChange={(value, newValue: any) => {
                    const selecteted = new Set();

                    newValue?.map(x => {
                      selecteted.add(x?.fa_category_id);
                    });

                    setSelectedFACategory(new Set(selecteted));
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        value={option?.fa_category_id}
                        style={{ marginRight: 8 }}
                        checked={selected}
                        color="primary"
                        onChange={event => {
                          handleCheckboxFACategoryChange(event);
                        }}
                      />
                      {option?.name}
                    </React.Fragment>
                  )}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          variant="outlined"
                          style={{ width: '100%' }}
                          label="Asset Type"
                          margin="normal"
                        />
                      </div>
                    );
                  }}
                />
              );
            }}
            name="AssetType"
            label="Asset Type"
            margin="normal"
            autoComplete="off"
            fullWidth
            multiline={true}
            control={control}
            select
            ref={register}
          />

          <Controller
            as={TextField}
            name="AssetCardNo"
            fullWidth
            label="Asset Card No"
            control={control}
            ref={register}
          />

          <Controller
            as={TextField}
            name="DocNo"
            fullWidth
            label="Asset No"
            control={control}
            ref={register}
          />

          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={getCostCentre || []}
                  getOptionLabel={option => option?.MasterCode}
                  fullWidth
                  onChange={(value, newValue: any) => {
                    const selecteted = new Set();

                    newValue?.map(x => {
                      selecteted.add(x?.CostCentreID);
                    });

                    setSelectedDepartment(new Set(selecteted));
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        value={option?.CostCentreID}
                        style={{ marginRight: 8 }}
                        checked={selected}
                        color="primary"
                        onChange={event => {
                          handleCheckboxDepartmentChange(event);
                        }}
                      />
                      <div>
                        <div>
                          <span className="xsTitle">{option?.MasterCode}</span>
                        </div>
                        <div className="desc">{option?.Name}</div>
                      </div>
                    </React.Fragment>
                  )}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          variant="outlined"
                          style={{ width: '100%' }}
                          label="Department"
                          margin="normal"
                        />
                      </div>
                    );
                  }}
                />
              );
            }}
            name="CostCentreID"
            label="Department"
            margin="normal"
            autoComplete="off"
            fullWidth
            multiline={true}
            control={control}
            select
            ref={register}
          />

          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={getFALocation || []}
                  getOptionLabel={option => option?.name}
                  fullWidth
                  onChange={(value, newValue: any) => {
                    const selecteted = new Set();

                    newValue?.map(x => {
                      selecteted.add(x?.fa_location_id);
                    });

                    setSelectedLocation(new Set(selecteted));
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        value={option?.fa_location_id}
                        style={{ marginRight: 8 }}
                        checked={selected}
                        color="primary"
                        onChange={event => {
                          handleCheckboxLocationChange(event);
                        }}
                      />
                      {option?.name}
                    </React.Fragment>
                  )}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          variant="outlined"
                          style={{ width: '100%' }}
                          label="Location"
                          margin="normal"
                        />
                      </div>
                    );
                  }}
                />
              );
            }}
            name="LocationID"
            label="Location"
            margin="normal"
            autoComplete="off"
            fullWidth
            multiline={true}
            control={control}
            select
            ref={register}
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="StartDate"
              label="Transaction Start Date"
              control={control}
              onChange={(date: Date | null) => {}}
              format="dd/MM/yyyy"
              value={watch('StartDate')}
              margin="normal"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className="left"
              defaultValue={editData?.StartDate ?? new Date()}
              helperText={errors?.StartDate?.message}
              error={errors?.StartDate ? true : false}
              showTodayButton
              fullWidth
            />
          </MuiPickersUtilsProvider>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="EndDate"
              label="Transaction End Date"
              control={control}
              onChange={(date: Date | null) => {
                setValue('EndDate', date);
              }}
              format="dd/MM/yyyy"
              value={watch('EndDate')}
              margin="normal"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className="right"
              defaultValue={editData?.EndDate ?? new Date()}
              helperText={errors?.EndDate?.message}
              error={errors?.EndDate ? true : false}
              showTodayButton
              fullWidth
            />
          </MuiPickersUtilsProvider>
        </CardContents>

        <AccountFooter
          options={[
            {
              name: 'Submit',
              onClick: () => {
                handleSubmit(onSubmit)();
              },
              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>
    </>
  );
};
